import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { lightGreen } from '@mui/material/colors'
import { WalletButton } from '@txnlab/use-wallet-ui-react';
import { Link } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { useMemo } from 'react';

function Alt({children}) {
  return <>{children}</>;
  // return <Typography component="span" sx={{fontWeight: 'normal'}} variant="inherit" color="primary">{children}</Typography>
}

function Header({ dimStep }) {

  const classes = useMemo(() => {
    return dimStep.step <= dimStep.breaks.header ? { root: 'fg-fade' } : {};
  }, [dimStep.step > dimStep.breaks.header]);

  const title = useMemo(() => dimStep.birthday ? `It Is Algorand's Birthday!` :  `Is It Algorand's Birthday?`, [dimStep.birthday]);

  return <AppBar position="static" classes={classes} sx={{ background: 'black', padding: 3 }}>
    <Box
      sx={{
        position: 'relative',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: { xs: 'space-between', lg: 'center' },
        gap: 2,
      }}
    >
      <Typography
        component={Link}
        to="/"
        variant="h1"
        color="primary"
        sx={{ fontSize: { xs: '16pt', md: '24pt' }, flexGrow: { xs: 1, lg: 0 }, textAlign: { xs: 'left', lg: 'center' }, textDecoration: 'none' }}
      >
        {title}
      </Typography>
      <Box
        sx={{
          flexShrink: 0,
          position: { lg: 'absolute' },
          right: { lg: 0 },
          top: { lg: '50%' },
          transform: { lg: 'translateY(-50%)' },
        }}
      >
        <WalletButton />
      </Box>
    </Box>
  </AppBar>
}

export default observer(Header);
